import { render, staticRenderFns } from "./JobStatusForm.vue?vue&type=template&id=31e2dc1c&"
import script from "./JobStatusForm.vue?vue&type=script&lang=js&"
export * from "./JobStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./JobStatusForm.vue?vue&type=style&index=0&id=31e2dc1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports